<section class="my-3">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-12">
        <div class="card shadow rounded">
          <div class="card-body px-lg-5 py-lg-5">
            <div class="text-center text-muted mb-5">
              <h4 class="heading-double fw-bold">{{ title }}</h4>
            </div>
            <form [formGroup]="feedbackForm" (ngSubmit)="save()">
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <input MyInput formControlName="name" class="form-control form-control-alternative"
                      placeholder="Your name" type="text">
                    <my-error controlName="name" errorKey="required">Name is required.</my-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <input MyInput formControlName="emailId" class="form-control form-control-alternative"
                      placeholder="Email address" type="text">
                    <my-error controlName="emailId" errorKey="required">Email Id is required.</my-error>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group mb-3">
                    <input MyInput formControlName="mobileNo" class="form-control form-control-alternative"
                      placeholder="Mobile number" type="text">
                    <my-error controlName="mobileNo" errorKey="required">Mobile No is required.</my-error>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group mb-3">
                    <textarea MyInput formControlName="message" class="form-control form-control-alternative" cols="80"
                      placeholder="Type a message..." rows="4">
                      </textarea>
                    <my-error controlName="message" errorKey="required">Message is required.</my-error>
                  </div>
                </div>
              </div>
              <button [disabled]="!feedbackForm.valid || loading" class="btn btn-primary btn-block btn-lg"
                type="submit">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>